import LogComponent from './log.component'
import LogAll from './all'

let logModule = angular.module('item', [
    LogAll
  ])

  .component('log', LogComponent)

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $stateProvider
      
      .state('log.all', {
        url: '/all/:page',
        component: 'logall'
      })
  })
  .name;

export default logModule;


// WEBPACK FOOTER //
// ./client/app/components/log/index.js